// @flow
'use strict';

import { compose } from 'redux';
import { connect } from 'react-redux';
import { reduxForm } from 'redux-form/immutable';
import { createStructuredSelector } from 'reselect';

import { rootSelector, aplicaFiltro } from 'reducers/cfe/filtro_estruturado';

import ModalBuscaEstruturada from './modal_busca_estruturada';

const mapStateToProps = createStructuredSelector({ initialValues: rootSelector });

export default compose(
    connect<*, *, *, *, *, *>(mapStateToProps),
    reduxForm({
      form: 'cfeFiltroEstruturado', enableReinitialize: true,
      onSubmit(form, dispatch) {
        dispatch(aplicaFiltro(form));
      },
    }),
)(ModalBuscaEstruturada);
